import { nextTick } from 'vue'

const SENSITIVE_SELECTORS = [
    // standard selectors
    'input[type="password"]',
    'input[type="email"]',

    // custom pii class selector
    '.pii',

    // name-based selectors
    'input[name*="phone"]',
    'input[name*="email"]',
    'input[name*="contact_person"]',
    'input[name*="vat"]',

    // prime-vue class selectors
    '.p-password',
].join(', ')

export function suppressSensitiveInputs() {
    const elements = document.querySelectorAll(SENSITIVE_SELECTORS)

    elements.forEach((el) => {
        if (!el.hasAttribute('data-hj-suppress')) {
            el.setAttribute('data-hj-suppress', '')
        }
    })
}

export function setupHotjarPrivacyGuard(router) {
    router.afterEach(() => {
        nextTick(() => {
            suppressSensitiveInputs()
        })
    })
}
